/* eslint-disable no-console */
export default {
    info: console.info,
    error: console.error
};
